import React from 'react';
import '../css/home.css'
import HomeMenu from '../components/HomeMenu';
import GenericPage from './GenericPage';

const HomePage = () => {
    return (
        <GenericPage active='Inicio'>
            <HomeMenu />
        </GenericPage>
    );
}

export default HomePage;
